import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {translate} from 'views/module';

import {DraftTextField} from '../AgentJobDraftFields';
import {getRecipientListDetail} from '../../agentJobTypeUtils';

const CaregiverSupportChatAgentJobDraft = (props) => {
  const {
    draftPayload,
    updatePayloadField,
  } = props;

  return (
    <Stack sx={{gap: 1.25}}>
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.To')}
        onChange={updatePayloadField('resourceRn')}
        value={draftPayload.resourceRn}
      />
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Conversation')}
        onChange={updatePayloadField('conversationRn')}
        value={draftPayload.conversationRn}
      />
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Requester')}
        onChange={updatePayloadField('requesterRn')}
        value={draftPayload.requesterRn}
      />
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Message')}
        multiline
        onChange={updatePayloadField('message')}
        value={draftPayload.message}
      />
    </Stack>
  );
};

CaregiverSupportChatAgentJobDraft.propTypes = {
  draftPayload: PropTypes.object.isRequired,
  updatePayloadField: PropTypes.func.isRequired,
};

const buildPayload = ({draftPayload}) => draftPayload;

const getDraftBody = (job) => job.actionPayload?.message || '';

const getListDetail = (job, participantDetails) => {
  const payload = job.actionPayload || {};

  return [
    getRecipientListDetail(participantDetails, payload.resourceRn || job.resourceRn),
    translate('case.Detail.AgentJobs.List.ChatMessage'),
  ].filter(Boolean).join(' - ');
};

export default {
  Draft: React.memo(CaregiverSupportChatAgentJobDraft),
  actionType: 'CAREGIVER_SUPPORT_CHAT',
  buildPayload,
  getDraftBody,
  getListDetail,
  label: translate('case.Detail.AgentJobs.ActionLabels.CaregiverSupportChat'),
};
